"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakeInfo = void 0;
class StakeInfo {
    constructor(args) {
        Object.assign(this, args);
    }
}
exports.StakeInfo = StakeInfo;
